// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__WqCT5","side_container":"Toggle_side_container__e2eYK"};